import { flow, Runtime } from "fp";

import * as Data from "~/Data";
import { Company } from "~/Company";
import * as Driver from "~/Driver";
import { Request } from "~/Request";

type QueryStringPrefix = {
  readonly prefix?: "&" | "?";
};

export const buildQueryString = ({
  reportingLocationIDs = [],
  branchIDs = [],
  prefix = "?",
}: Get.Params & QueryStringPrefix) => {
  const parts = [];
  const branchFilterValues = Company.Branch.Branches.Filter.parseValues(
    branchIDs
  );
  /* eslint-disable functional/immutable-data */
  if (reportingLocationIDs.length > 0) {
    parts.push(`reporting_location_ids=${reportingLocationIDs.join(",")}`);
  }
  if (branchFilterValues.branchIDs.length > 0) {
    parts.push(`branch_ids=${branchFilterValues.branchIDs.join(",")}`);
  }
  if (branchFilterValues.includeNoBranch) {
    parts.push("include_no_branch=true");
  }
  /* eslint-enable functional/immutable-data */

  return parts.length > 0 ? `${prefix}${parts.join("&")}` : "";
};

export namespace Get {
  export type Params = {
    readonly reportingLocationIDs?: Driver.Filter.Filter;
    readonly branchIDs?: Driver.Filter.BranchFilter;
  };

  /** [API Documentation](http://equipmentshare.pages.internal.equipmentshare.com/equipmentshare-api/develop/index.html?highlight=drivers#get--companies-(int-company_id)-drivers) */
  export const request = (
    { company }: Company,
    filterParams?: Params
  ): Data.Cache.Request<Driver.Driver> => {
    const filterDefaults: Params = {
      branchIDs: [],
      reportingLocationIDs: [],
    };
    const { branchIDs, reportingLocationIDs } = filterParams ?? filterDefaults;
    const queryString = buildQueryString({
      reportingLocationIDs,
      branchIDs,
    });

    return flow(
      Request.fromConfig({
        endpoint: `/companies/${company.id}/drivers` + queryString,
      }),
      Request.Expect.status(200),
      Request.Expect.json(Runtime.array(Driver.Response.runtime())),
      Request.onSuccess(
        Data.Cache.fromList((response) => [
          `${response.driver_id}`,
          Driver.Response.decode(response),
        ])
      )
    );
  };
}
